export enum ProposalStatus {
  Pending,
  Canceled,
  Approved,
  Executed,
}
